import { createTheme } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";
import { baseTheme } from "../index";

export const colors = {
  // hrv_primary: "#BD48E8",
  // hrv_black: "#2e2e2e",
  // hrv_error: "#d83144",
  // hrv_medium_gray: "#636363",
  // hrv_white: "#fff",
  // hrv_border_color: "#e8e8e8",
  // hrv_light_gray: "#fafafa",
  // hrv_info_main: "#9739B9",
  // hrv_info_light: "#F1DAFA",
  // hrv_info_dark: "#BD48E8",
  // hrv_graphs: "rgb(90, 165, 227, 1)",
  hrv_primary: "#FD5B6E", // primary
  hrv_error: "rgb(206, 64, 64, 1)",
  hrv_medium_gray: "rgb(140, 140, 140, 1)",
  hrv_black: "#424242", // secondary
  hrv_blue: "rgb(76, 120, 219, 1)",
  hrv_white: "#fff",
  hrv_border_color: "#e8e8e8",
  hrv_light_gray: "#fafafa",
  hrv_info_main: "#CA4858",
  hrv_info_dark: "#FD5B6E",
  hrv_info_light: "#FEDEE2",
  hrv_action_main: "#3BB78F",
  hrv_info_gmain: "#2493BC",
  hrv_graphs: "#FD5B6E",
};

export const adminTheme = createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    primary: { main: colors.hrv_primary },
    secondary: { main: colors.hrv_black },
    error: { main: colors.hrv_error },
    info: {
      main: colors.hrv_info_main,
      light: colors.hrv_info_light,
      dark: colors.hrv_info_dark,
    },
  },
  overrides: {
    ...baseTheme.overrides,
    MuiButton: {
      ...baseTheme.overrides.MuiButton,
      text: {
        color: colors.hrv_primary,
      },
    },
  },
});
